export default "__VITE_ASSET__602777bd__"